module.exports = __webpack_public_path__ + "img/lachskaviarsushifrontal.e69ee622.png";